import { render, staticRenderFns } from "./HJ212Stat.vue?vue&type=template&id=b29a3136&scoped=true&"
import script from "./HJ212Stat.vue?vue&type=script&lang=js&"
export * from "./HJ212Stat.vue?vue&type=script&lang=js&"
import style0 from "./HJ212Stat.vue?vue&type=style&index=0&id=b29a3136&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b29a3136",
  null
  
)

export default component.exports